/*** IMPORTS FROM imports-loader ***/
var global = window;

// Is a given variable undefined?
export default function isUndefined(obj) {
  return obj === void 0;
}

